import maplibregl from 'maplibre-gl'
import { ensureRouteArrowImage, ROUTE_ARROW_IMAGE_ID } from './routeArrow'

export function initPlanLayer(map: maplibregl.Map) {
    if (!map.getSource('planView')) {
        map.addSource('planView', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [],
            },
        })

        ensureRouteArrowImage(map)

        // Casing drawn first (behind), providing a darker border on each side
        map.addLayer({
            id: 'planView-casing',
            type: 'line',
            source: 'planView',
            layout: { 'line-cap': 'round', 'line-join': 'round' },
            paint: {
                'line-color': ['coalesce', ['get', 'casingColor'], 'rgba(0,0,0,0.4)'],
                'line-width': 9,
                'line-opacity': 0.75,
            },
        })

        // Main colored route line
        map.addLayer({
            id: 'planView',
            type: 'line',
            source: 'planView',
            layout: { 'line-cap': 'round', 'line-join': 'round' },
            paint: {
                'line-color': ['get', 'color'],
                'line-width': 5,
                'line-opacity': 0.75,
            },
        })

        // Direction chevrons along the line
        map.addLayer({
            id: 'planView-arrows',
            type: 'symbol',
            source: 'planView',
            layout: {
                'symbol-placement': 'line',
                'symbol-spacing': 125,
                'icon-image': ROUTE_ARROW_IMAGE_ID,
                'icon-size': 0.65,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
                'icon-rotation-alignment': 'map',
                'icon-pitch-alignment': 'map',
            },
            paint: {
                'icon-opacity': 0.75,
            },
        })
    }

    if (!map.getSource('planVehicleLocations')) {
        map.addSource('planVehicleLocations', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [],
            },
        })
        map.addLayer({
            id: 'planVehicleLocations',
            type: 'symbol',
            source: 'planVehicleLocations',
            layout: {
                'icon-image': ['concat', 'vehicle-', ['get', 'color_id']],
                'icon-size': 1,
                'icon-rotate': ['coalesce', ['get', 'heading'], 0],
                'icon-rotation-alignment': 'map',
                'icon-pitch-alignment': 'map',
                'icon-allow-overlap': true,
            },
            paint: {
                'icon-opacity': 1,
            },
        })
    }
}
